import * as Sentry from "@sentry/gatsby";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://3b1797369a4e40f58602acf64beaa158@o270912.ingest.sentry.io/6682687",
    tracesSampleRate: 0.4,
    ignoreErrors: [
      "Large HTTP payload",
      /feature named .* was not found/i,
      /null.*scrollX/,
      /play\(\) request was interrupted/,
      /NS_ERROR_NOT_INITIALIZED/i,
    ],
    denyUrls: [
      /ftUtils\.js/,
      /wrapper\.min\.js/,
      /scriptwrapper/,
      /optable/,
      /ef1ce393/,
      /ym\.\d+\.js/,
      /mc\.yandex/,
      /profiles\/jyucq/,
      /blob\/aee897/,
    ],
  });
}
